<template>
  <div class="headertop" ref="headertop">
    <div class="container">
      <div class="fl logo">电子留言</div>
      <menus></menus>
    </div>
  </div>
</template>

<script>
import Menus from '@/views/common/menus'
export default {
  name: 'mobiletop',
  components: {
    Menus
  },
  data () {
    return {
      headerheight: 0
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    headerHeight () {
      this.headerheight = this.$refs.headertop.clientHeight
      this.$emit('headtop', this.headerheight)
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/index';
.headertop{
  height: 100px;
  background: #a11b00;
  .logo{
    padding: 30px 0 0;
    font-size: 30px;
    color: #fff;
    float: left;
  }
  .menubtn{
    width: auto;
    right: auto;
    bottom: auto;
    background: none;
    position: relative;
    float: right;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    height: auto;
    .btnselect{
      display: none;
    }
    ul{
      display: block;
      li{
        float: left;
        margin: 0 0 0 60px;
        padding: 18px 0 0;
        a{
          img{
            width: 40px;
            height: 40px;
          }
          span{
            font-size: 16px;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/common/pctop.vue